<template>
  <div>
    <span v-if="ordinaria" class="size-status" style="color: green">
      <v-icon small color="green" class="icon-status pb-1">mdi-thumb-up-outline</v-icon>
      Ordinária
    </span>
    <span v-else class="size-status" style="color: red">
      <v-icon small color="red" class="icon-status pb-1">mdi-thumb-down-outline</v-icon>
      Não ordinária
    </span>
  </div>
</template>

<script>
  export default {
    name: 'BdgdOrdinaria',
    props: {
      ordinaria: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }

  .size-status .v-icon {
    font-size: 0.9rem !important;
  }

  .icon-status {
    margin-right: 1.7px !important;
  }
</style>
